
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moje-konto/anuluj-zamowienie",
      function () {
        return require("private-next-pages/moje-konto/anuluj-zamowienie/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moje-konto/anuluj-zamowienie"])
      });
    }
  